<template>
  <div>
    <div>
      <slot name="icon"></slot>
      <span v-if="updated">Updated</span>
      <span v-if="created">Created</span>
      {{getTimeSince(time)}}
      <span v-if="!!createdTime">/ Created {{getTimeSince(createdTime)}}</span>
      <span v-if="!!subject">
        <span v-if="!!subject.updatedBy">by {{subject.updatedBy.name}}</span>
      </span>
    </div>
    <div v-if="!!subject">
      <div v-if="!!subject.createdBy">
        <slot name="icon"></slot>
        <span>Created by {{subject.createdBy.name}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    getTimeSince(date) {
      if (this.needsParse) {
        date = Date.parse(date)
      }

      date = Number(date)

      var seconds = Math.floor((new Date() - date) / 1000)
      var interval = Math.floor(seconds / 31536000)

      if (interval >= 1) {
        return interval + ' years ago'
      }
      interval = Math.floor(seconds / 2592000)
      if (interval >= 1) {
        return interval + ' months ago'
      }
      interval = Math.floor(seconds / 86400)
      if (interval >= 1) {
        return interval + ' days ago'
      }
      interval = Math.floor(seconds / 3600)
      if (interval >= 1) {
        return interval + ' hours ago'
      }
      interval = Math.floor(seconds / 60)
      if (interval >= 1) {
        return interval + ' minutes ago'
      }
      if (seconds < 30) {
        return 'Recently'
      }
      return Math.floor(seconds) + ' seconds ago'
    },
  },
  props: {
    time: String,
    updated: Boolean,
    subject: Object,
    created: Boolean,
    createdTime: String,
    needsParse: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
}
</script>

<style>
</style>
